module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0346-min.ebe17216.jpg";